import React, { useState } from 'react'
import {
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { AdminPermission } from './adminPermission'
import { useVersion } from '../hooks/useVersion'

const NavBar = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { version, loading } = useVersion();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
      <header className="position-sticky sticky-top">
        <Navbar color="dark" dark expand="md">
          <Container fluid>
            <NavbarBrand href="/">
              RentSlam Cms {loading ? '(loading...)' : `(${version?.displayVersion || 'v1.2.7'})`}
            </NavbarBrand>
            <NavbarToggler onClick={toggle} className="mr-2"/>
            <Collapse isOpen={isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem>
                  <NavLink tag={Link} className="text-light" to="/users">
                    Users
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-light" to="/parsedhouses">
                    Parsed houses
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-light"
                           to="/testimonials">
                    Testimonials
                  </NavLink>
                </NavItem>
                <AdminPermission user={user}>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/payments">
                      Payments
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/parsers">
                      Parsers
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/sources">
                      Sources
                    </NavLink>
                  </NavItem>
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      Search criteria
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>
                        <Link className="dropdown-item"
                              to="/furnishingcriteria">
                          Furnishing
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link className="dropdown-item" to="/cities">
                          Cities
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link className="dropdown-item" to="/postcodes">
                          Postcodes
                        </Link>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <NavItem>
                    <NavLink tag={Link} className="text-light"
                             to="/reportedproblems">
                      Reported Problems
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/diagnostics">
                      Diagnostics
                    </NavLink>
                  </NavItem>
                </AdminPermission>
                <NavItem>
                  <NavLink tag={Link} className="text-light" to="/feedback">
                    Feedback
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-light" to="/houses">
                    Houses
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-light"
                           to="/statsperneighbourhood">
                    Stats
                  </NavLink>
                </NavItem>
                {!user && (
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/login">
                      Login
                    </NavLink>
                  </NavItem>
                )}
                {user && (
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/logout">
                      logout {user.name}
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
};

export default NavBar;
